import { Component, Input, OnInit } from '@angular/core';
import { ClientForUser } from '@core/typings/auth.typing';
import { YCModalComponent } from '@yourcause/common/modals';

@Component({
  selector: 'gc-client-picker-modal',
  templateUrl: './client-picker-modal.component.html',
  styleUrls: ['./client-picker-modal.component.scss']
})
export class ClientPickerModalComponent extends YCModalComponent<number> implements OnInit {
  @Input() associatedClients: ClientForUser[];
  selectedClient: ClientForUser;

  ngOnInit () {
    this.selectedClient = this.associatedClients[0];
  }
}
